import {
  extractSentryEventStatusCode,
  extractSentryEventUrl,
  type SentryEventLike,
} from './sentryEventFields';

const GRAPHQL_PATH_FRAGMENT = '/graphql';

export const shouldDropHandledGraphql500 = (
  event: SentryEventLike
): boolean => {
  const url = extractSentryEventUrl(event);
  const statusCode = extractSentryEventStatusCode(event);

  return (
    url.includes(GRAPHQL_PATH_FRAGMENT) && !!statusCode && statusCode >= 500
  );
};
